import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import { handleApiError } from "@/utils/apiErrorHandler";
import { clearError } from "./errorSlice";
import { TagValues } from "@/types/enums";

// Define fetchTags
export const fetchTags = createAsyncThunk(
  "tags/fetchTags",
  async (_, { dispatch }) => {
    try {
      // Clear any previous errors from this slice when starting a new request
      dispatch(clearError());
      
      const response = await axios.get(
        `/papi/tags?cacheBuster=${Date.now()}`
      );
      const allowedTags = Object.values(TagValues);
      const filteredTags = response.data
        .filter((tag: { name: string }) =>
          allowedTags.includes(tag.name as TagValues)
        )
        .sort((a: { name: string }, b: { name: string }) => {
          if (a.name === TagValues.OTHER) return 1;
          if (b.name === TagValues.OTHER) return -1;
          return a.name.localeCompare(b.name);
        });
      return filteredTags;
    } catch (error) {
      handleApiError(error as AxiosError, "tags", dispatch);
      throw error;
    }
  }
);

const initialState = {
  tags: [],
  loading: false,
  error: null as string | null,
};

const tagsSlice = createSlice({
  name: "tags",
  initialState,
  reducers: {
    // Define reducers if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTags.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTags.fulfilled, (state, action) => {
        state.loading = false;
        state.tags = action.payload;
      })
      .addCase(fetchTags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? null;
      });
  },
});

export default tagsSlice.reducer;
